<script setup>
import { useLoadingStore } from "../Store/index";

const loadingStore = useLoadingStore();
</script>

<template>
    <div v-if="loadingStore.loading">
        <div
            class="fixed top-0 left-0 z-50 h-full w-full bg-gray-800 opacity-20"
        ></div>
        <svg
            class="fixed top-[50%] left-[50%] z-50 h-[100px] w-[100px] -translate-x-1/2 -translate-y-1/2"
            version="1.1"
            id="L9"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 100 100"
            enable-background="new 0 0 0 0"
            xml:space="preserve"
        >
            <path
                fill="black"
                d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
            >
                <animateTransform
                    attributeName="transform"
                    attributeType="XML"
                    type="rotate"
                    dur="1s"
                    from="0 50 50"
                    to="360 50 50"
                    repeatCount="indefinite"
                />
            </path>
        </svg>
    </div>
</template>
